import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL


const candidateRequest = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor
candidateRequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      // Backend's verifyToken middleware does not strip a Bearer
      // prefix — send the raw token only.
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default candidateRequest;